import React from 'react';
import { Button, Modal } from 'react-bootstrap';
import LoadingLoginScreen from './LoadingLoginScreen';
import {useAuth} from '../contexts/AuthContext';
export const VerifyEmail = ({ emailVerified }) => {

    const [loading, setLoading] = React.useState(false);
    const [verify, setVerify] = React.useState(false);
    const {handleEmailVerification} = useAuth();
    const handleVerifyEmail = async () => {
        setLoading(true);

        await handleEmailVerification();
        
        setLoading(false);

    }



    return (
        <>
            {emailVerified ? "Din email är verifierad" :
                <Button onClick={handleVerifyEmail} disabled={loading}>
                    Verifiera din email
                </Button>
            }
            <Modal
                show={verify}
            >
                {loading ? <LoadingLoginScreen /> : null}

            </Modal>
        </>
    )
}